<template>
  <div>
    <div>
      <div v-loading="loading">
        <el-descriptions
          class="mb-2"
          border
          size="small"
          :column="2"
          :labelStyle="{ width: '100px' }"
        >
          <el-descriptions-item
            :label="$l('form_label_ncNo') || 'NC编号'"
            :contentStyle="{ width: '280px' }"
          >
            {{ orderGoods.ncNo }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_identifyGoodsNo') || '产品识别号'"
          >
            {{ orderGoods.identifyGoodsNo }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_orderGoodsName') || '产品名称'"
          >
            <span v-if="orderGoods.v_isGroup" class="mr-2">
              <el-tag
                size="mini"
                :type="orderGoods.isGroup == 'Y' ? 'warning' : ''"
              >
                {{ orderGoods.v_isGroup }}
              </el-tag>
            </span>
            <span class="mr-1">{{ orderGoods.orderGoodsName }}</span>
            <span>{{ orderGoods.orderGoodsColor }}</span>
          </el-descriptions-item>
        </el-descriptions>

        <div v-if="orderGoods.isGroup == 'Y'">
          <el-descriptions
            border
            size="small"
            :column="1"
            :labelStyle="{ width: '100px' }"
          >
            <el-descriptions-item
              :label="$l('form_label_orderGoodsGroupSpecNcNo') || '子件NC编号'"
            >
              {{ orderGoodsSpec.ncNo || '' }}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions
            border
            size="small"
            :column="3"
            class="bottom-desc"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '280px' }"
          >
            <el-descriptions-item
              :label="$l('form_label_orderGoodsGroupSpecName') || '子件名称'"
            >
              {{ orderGoodsSpec.orderGoodsSpecName || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_orderGoodsGroupSpecSize') || '子件规格'"
            >
              {{ showSpec }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_inGroupQty') || '套内数量'"
            >
              {{ orderGoodsSpec.inGroupQty }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_fabricCost') || '面料成本'"
            >
              {{ fabricCost }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_materialCost') || '辅料成本'"
            >
              {{ materialCost }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_laborCost') || '人工成本'"
            >
              {{ laborCost }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div v-if="orderGoods.isGroup == 'N'">
          <el-descriptions
            border
            size="small"
            :column="2"
            :labelStyle="{ width: '100px' }"
          >
            <el-descriptions-item
              :label="$l('form_label_orderGoodsSpecName') || '规格名称'"
              :contentStyle="{ width: '280px' }"
            >
              {{ orderGoodsSpec.orderGoodsSpecName || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_showSpec') || '规格尺寸'"
            >
              {{ showSpec }}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions
            border
            size="small"
            :column="3"
            class="bottom-desc"
            :labelStyle="{ width: '100px' }"
            :contentStyle="{ width: '280px' }"
          >
            <el-descriptions-item
              :label="$l('form_label_fabricCost') || '面料成本'"
            >
              {{ fabricCost }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_materialCost') || '辅料成本'"
            >
              {{ materialCost }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_laborCost') || '人工成本'"
            >
              {{ laborCost }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <GoodsSpecFabric
        ref="goodsSpecFabric"
        :disabled="disabled"
        :pdCostsOrderGoodsSpecCode="pdCostsOrderGoodsSpecCode"
        @reload="getData"
      />
      <GoodsSpecMaterial
        ref="goodsSpecMaterial"
        class="mt-2"
        :disabled="disabled"
        :pdCostsOrderGoodsSpecCode="pdCostsOrderGoodsSpecCode"
        @reload="getData"
      />
      <GoodsSpecProcess
        ref="goodsSpecProcess"
        class="mt-2"
        :disabled="disabled"
        :pdCostsOrderGoodsSpecCode="pdCostsOrderGoodsSpecCode"
        @reload="getData"
      />
    </div>
  </div>
</template>

<script>
import GoodsSpecFabric from '../goods-spec-fabric'
import GoodsSpecMaterial from '../goods-spec-material'
import GoodsSpecProcess from '../goods-spec-process'
import { format } from '@/libs/util.number.js'
export default {
  components: { GoodsSpecFabric, GoodsSpecMaterial, GoodsSpecProcess },
  props: {
    disabled: { type: Boolean, default: false },
    pdCostsOrderGoodsSpecCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      orderGoods: {},
      orderGoodsSpec: {},
    }
  },
  computed: {
    fabricCost() {
      return format(this.orderGoodsSpec.fabricCost)
    },
    materialCost() {
      return format(this.orderGoodsSpec.materialCost)
    },
    laborCost() {
      return format(this.orderGoodsSpec.laborCost)
    },
    totalCostAmount() {
      return format(this.orderGoodsSpec.totalCostAmount)
    },
    quote() {
      return format(this.orderGoodsSpec.quote)
    },
    showSpec() {
      const { spec, specUnit } = this.orderGoodsSpec
      return [spec, specUnit].filter(Boolean).join(' ')
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const data = await this.getGoodsSpec(this.pdCostsOrderGoodsSpecCode)
      if (data) {
        const { pdCostsOrderGoodsCode } = data
        this.orderGoods = await this.getGoods(pdCostsOrderGoodsCode)
        this.orderGoodsSpec = { ...data }
      }
      this.loading = false
    },
    async getGoods(pdCostsOrderGoodsCode) {
      if (!pdCostsOrderGoodsCode) return
      const res = await this.$api
        .pdCostsOrderGoodsDetailApi({ pdCostsOrderGoodsCode })
        .catch(() => null)
      if (!res) return
      return res.body
    },
    async getGoodsSpec(pdCostsOrderGoodsSpecCode) {
      if (!pdCostsOrderGoodsSpecCode) return
      const res = await this.$api
        .pdCostsOrderGoodsSpecDetailApi({ pdCostsOrderGoodsSpecCode })
        .catch(() => null)
      if (!res) return
      return res.body
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
</style>
